/* The board's stages.
 *
 * Everybody signed in reads them; the office changes them, and the server
 * answers 403 to anyone else. Every write answers with the whole list in board
 * order — making one stage the default takes it off another, and a reorder
 * moves them all — so the store replaces its list with the answer rather than
 * splicing one stage into it. */
import type {
  CreateStageRequest,
  ReorderStagesRequest,
  StageDto,
  UpdateStageRequest,
} from '@oneshot2pac/shared';
import { api } from './client';

export const stagesApi = {
  list: () => api.get<StageDto[]>('/stages'),

  /** A new stage goes on the end of the board. */
  create: (body: CreateStageRequest) => api.post<StageDto[]>('/stages', body),

  /** Send only what changed. A rename never changes the stage's id. */
  update: (id: string, body: UpdateStageRequest) =>
    api.patch<StageDto[]>(`/stages/${encodeURIComponent(id)}`, body),

  /** Every stage on the board, first to last. */
  reorder: (body: ReorderStagesRequest) => api.put<StageDto[]>('/stages/order', body),

  /** Off the board. Only ever an empty stage, and never the default. */
  archive: (id: string) => api.post<StageDto[]>(`/stages/${encodeURIComponent(id)}/archive`),
};
